import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGripVertical,
  faInfinity,
  faRotate,
} from "@fortawesome/free-solid-svg-icons";
import SystemUsageIcon from "../../../assets/icons/system_usage.svg2";
import AvailableUpgrades from "../../Dashboard/AvailableUpgrades";
import { useGetInteractionsWidgetDataQuery } from "../../store/slices/widgetsSlice";
import HelpButton from "../../HelpContent/HelpButton";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";

export default function SystemUsageWidget() {
  const {
    data = { used: 0, remaining: 0 },
    isLoading,
    isFetching,
    refetch,
  } = useGetInteractionsWidgetDataQuery();
  const loading = isLoading || isFetching;

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonth = months[new Date().getMonth()];
  const currentYear = new Date().getFullYear();

  return (
    <div className="h-100 text-white rounded-3 position-relative">
      <AbsoluteLoadingIndicator loading={loading} />
      <div className="p-3 d-flex flex-column h-100">
        <div className="">
          <SystemUsageIcon width={20} className="me-2 white opacity-50" />
          <span className="small fw-bold "> SYSTEM USAGE </span>
          <button
            className="btn p-0 text-white ms-2"
            onClick={() => refetch()}
            title="Refresh system usage data"
            disabled={loading}
          >
            <FontAwesomeIcon
              icon={faRotate}
              className={`opacity-50 ${loading ? "spin" : ""}`}
            />
          </button>
          <HelpButton helpKey="widget-system-usage" iconClassName="white" />
          <FontAwesomeIcon
            icon={faGripVertical}
            className="ms-4 opacity-50 widget-header"
          />
          <hr className="text-white my-2" />
        </div>
        <div className="flex-grow-1 d-flex flex-column justify-content-center h-100 align-items-center">
          <div className="row p-2 text-center">
            <div className="bg-dark bg-opacity-25 rounded-3 px-4 py-3 col-6">
              <div className="fw-bold small">CURRENT ITEMS</div>
              <div className="opacity-50 " style={{ fontSize: "0.75rem" }}>
                interactions used
              </div>
              <div className="display-3 fw-bold">{data.used}</div>
              <div className="opacity-50" style={{ fontSize: "0.75rem" }}>
                {currentMonth} - {currentYear}
              </div>
            </div>
            <div className="px-4 py-3 col-6">
              <div className="fw-bold small">UNUSED ITEMS</div>
              <div className="opacity-50" style={{ fontSize: "0.75rem" }}>
                refreshes monthly
              </div>
              {data.remaining === -1 ? (
                <div>
                  <div className="display-3 fw-bold">
                    <FontAwesomeIcon icon={faInfinity} />
                  </div>
                  UNLIMITED
                </div>
              ) : (
                <div>
                  <div className="display-3 fw-bold">{data.remaining}</div>
                  <AvailableUpgrades />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
